import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import EditAttachments from '@/views/components/file/edit_attachments_v1'
import FileUploader from '@/views/components/file/uploader.vue'
import { getsafe } from '@/libs/util.js'
import {postEpopMonthlyRecordAddScreenShotApi} from '@/views/fin/account_management/services.js'
export default {
    data() {
        this.fields = [
            {
                key: 'upload'
            }
        ]
        return {
            show: false,
            saving: false,
            params: {
                bfiles: [],
            },
            uploading:false
        }
    },
    methods: {
        edit(data) {
            console.log('data', data)
            this.show = true
            this.params.id = data.id
            this.params.bfiles = getsafe(data, 'screenshots', [])
        },
        submit() {
        
            const bfiles = getsafe(this, 'params.bfiles', [])
            if (!bfiles.length) {
                this.$Message.error('请上传图片！')
                return 
            }
            const params = {
                id: this.params.id,
                bfiles: this.params.bfiles
            }
            this.saving = true
            postEpopMonthlyRecordAddScreenShotApi(params).then(() => {
                    this.show = false
                    this.$emit('success')
            }).finally(() => {
                this.saving = false
            })
        }
    },
    render() {
        const _this = this
        return <VModal
            dynamicHeight
            heightRate={0.8}
            v-model={_this.show}
            title="图片"
            loading={_this.saving}
            width={600}
            ref="modal"
            ok-text="保存"
            on={{
                ok: this.submit,
                cancel:() => {
                    this.show = false
              
                }
            }}
        >
            <VForm ref="base"
                v-model={_this.params}
                fields={_this.fields}
                scopedSlots={{
                    upload:() => {
                        return <div style="display:flex">
                            <p style="width:40px">
                                附件
                            </p>
                            <div style="flex:1">
                                <EditAttachments
                                    files={ _this.params.bfiles}
                                    modelType="EpopAccountMonthlyRecord"
                                    modelId={_this.params.id}
                                    />
                                    <FileUploader 
                                        multiple={false}
                                        format={['jpg', 'jpeg', 'png']}
                                     disabled={_this.params.bfiles.length >= 2}
                                        validateFile={(file) => {
                                            const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                            if (!a) {
                                                this.$vModal.warning({
                                                    title:'提示',
                                                    content:'文件格式错误，无法解析。'
                                                })
                                            }
                                            return a
                                        }}
                                         on={{
                                        uploaded: (bfile) => {
                                            _this.params.bfiles.push(bfile)
                                        }
                                    }}/>
                                  
                            </div>
                        </div>
                    },
                 }}
                />
        </VModal>}
}